<template>
  <section v-if="multiplierCards.length > 0 && card.collectionCardId" class="card-profile-multipliers">
    <align class="section-header">
      <h4 class="secondary-font">
        Multipliers
      </h4>

      <icon-button
        tooltip="Edit Multipliers"
        class="edit"
        icon="edit"
        @click="edit"
      />
    </align>

    <template v-if="multiplierCards.length > 0">
      <div class="list">
        <card-list-item
          v-for="multiplier in multiplierCards"
          :key="multiplier.id"
          :card="multiplier"
          :fields="['currentValue']"
          :custom-fields="[{
            label: 'Multiplier',
            value: `${$filters.decimal(multiplier.value)}x`,
          }]"
          :to="{ name: $route.name, params: { ...$route.params, id: multiplier.card }, query: { ...$route.query, profile: 'ladder' } }"
          as="router-link"
        />
      </div>
    </template>
  </section>
</template>

<script>
import { getMultiplierCardsProfileDisplay } from '@cardladder/shared/utils/ladder.util';

import CardListItem from '@cardladder/shared/components/CardListItem';

export default {
  components: {
    CardListItem,
  },

  props: {
    card: Object,
  },

  computed: {
    multiplierCards() {
      return getMultiplierCardsProfileDisplay(this.card);
    },
  },

  methods: {
    edit() {
      this.$bus.$emit('collection-edit-card-value', {
        id: this.card.collectionCardId,
        collectionId: this.card.collectionId,
        display: 'valueMultipliers',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-profile-multipliers {
  padding-top: $gp;
  border-top: solid 1px var(--theme-border);
  margin-bottom: $gp * 1.5;
}

.section-header {
  margin-bottom: $gp * .25;

  h4 {
    margin-bottom: 0;
  }
}

.list {
  margin: 0 (-$gp);
}
</style>
